<template>
    <div
        :id="id"
        :class="classString"
    >
        <h2 class="lni-u-heading--3">
            {{ text.employerInformation }}
        </h2>
        <div class="lni-u-form-width--base">
            <lni-input-text
                :id="`${id}_name`"
                class="lni-u-mv2"
                :labelText="text.companyName"
                :required="true"
                :fullWidth="true"
                :changeAction="`${id}/syncStore`"
            />
        </div>
        <lni-input-phone
            :id="`${id}_phone`"
            :labelText="text.companyPhone"
            :isFieldset="false"
            :changeAction="`${id}/syncStore`"
        />
        <lni-input-email
            :id="`${id}_email`"
            class="lni-u-mb2"
            :labelText="text.companyEmail"
            :isFieldset="false"
            :changeAction="`${id}/syncStore`"
        />
        <lni-input-address
            :id="`${id}_address`"
            :labelText="text.companyAddress"
            :filled="true"
            :changeAction="`${id}/syncStore`"
            state="WA"
        /><lni-checkbox
            :id="`${id}_address-differs`"
            class="lni-u-mb2"
            :labelText="text.addressDiffers"
            :hasInlineMessages="false"
            @change="toggleLocationAddress"
        />
        <lni-collapse :id="`${id}_address-collapse`">
            <lni-input-address
                :id="`${id}_location-address`"
                :labelText="text.locationAddress"
                :filled="true"
                :changeAction="`${id}/syncStore`"
                state="WA"
            />
        </lni-collapse>
        <fieldset class="lni-u-full-width lni-u-flex lni-u-flex-wrap">
            <legend class="lni-u-heading--4">
                {{ text.supervisorContact }}
            </legend>
            <lni-input-text
                :id="`${id}_contact-first-name`"
                class="lni-u-mr1 lni-u-mb2"
                :labelText="text.firstName"
                :changeAction="`${id}/syncStore`"
            />
            <lni-input-text
                :id="`${id}_contact-last-name`"
                class="lni-u-mb2"
                :labelText="text.lastName"
                :changeAction="`${id}/syncStore`"
            />
        </fieldset>
        <lni-input-phone
            :id="`${id}_contact-phone`"
            class="lni-u-mb2"
            :labelText="text.phone"
            :isFieldset="false"
            :hasExtension="false"
            :changeAction="`${id}/syncStore`"
        />
    </div>
</template>

<script>
export default {
    name : 'LniChildLaborComplaintEmployer',
    props: {
        classString: {
            type   : String,
            default: '',
        },
        text: {
            type    : Object,
            required: true,
        },
    },
    emits: ['update-add'],
    mounted() {
        this.$store.commit('setAttribute', {
            id       : this.id,
            attribute: 'trackedErrors',
            value    : [
                `${ this.id }_name`,
                `${ this.id }_phone`,
                `${ this.id }_email`,
                `${ this.id }_address`,
                `${ this.id }_location-address`,
                `${ this.id }_contact-first-name`,
                `${ this.id }_contact-last-name`,
                `${ this.id }_contact-phone`,
            ],
        }, { root: true });

        this.$emit('update-add', this.trackedErrors);
    },
    methods: {
        toggleLocationAddress() {
            const addressDiffers = this.$store.state[`${ this.id }_address-differs`].checked;

            this.$store.commit('setAttribute', {
                id       : `${ this.id }_address-collapse`,
                attribute: 'visible',
                value    : addressDiffers,
            }, { root: true });

            if (!addressDiffers) {
                const targetId = `${ this.id }_location-address`;
                const addressAttributes = [
                    'address1',
                    'address2',
                    'city',
                    'state',
                    'zip',
                ];
                addressAttributes.forEach(attribute => {
                    const isState = attribute === 'state';

                    this.$store.commit('setAttribute', {
                        id   : targetId,
                        attribute,
                        value: isState ? 'WA' : '',
                    }, { root: true });

                    this.$store.commit('setAttribute', {
                        id       : `${ targetId }_${ attribute }`,
                        attribute: 'value',
                        value    : isState ? 'WA' : '',
                    }, { root: true });
                });
            }

            this.$store.dispatch(`${ this.id }/syncStore`);
        },
    },
};
</script>